export default __webpack_public_path__ + "static/media/leaderboard.594f8d7f.png";